import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { EmitterService } from "src/app/EmitterService";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit, OnDestroy {
    currentYear: any;
    loadingData: boolean = true;
    subscription: Subscription;
    mainData: any;
    mapUrl: SafeResourceUrl;

    constructor(
        private emitterService: EmitterService,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        this.currentYear = new Date().getFullYear();
        this.subscription = this.emitterService.currentMessage.subscribe(
            (message) => {
                if (message === true) {
                    this.loadingData = false;
                    let storedData = localStorage.getItem("mainData");
                    if (storedData != null) {
                        this.mainData = JSON.parse(storedData);
                        let url = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3596.5063111716345!2d88.98158767539684!3d25.6545057774194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fcb32bf564ca19%3A0x5d27abc6bb22bda!2sA!5e0!3m2!1sen!2sbd!4v1782905393809!5m2!1sen!2sbd`;
                        this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                    }
                }
            }
        );
    }
    
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}